<template>
  <div class="flex flex-col overflow-hidden bg-white">
    <div class="flex flex-row bg-white justify-between items-center px-10 h-14 my-4">
      <div class="text-dark text-2xl font-semibold h-15 text-center mr-auto">DOCTOR CHAT AVAILABILITY</div>
      <div class="flex flex-row justify-between m-2 ml-auto">
        <div class="flex">
          <select @change="onMonthYearChange" v-model="selectedMonth.value" class="flex appearance-none mr-2 w-auto h-8 pl-2 bg-white border border-solid rounded-sm border-grey-lightest text-sm text-grey-darkest focus:border-blue">
            <option v-for="(month,index) in months"  :key="index" v-bind:value="month.value">
              {{ month.text }}
            </option>
          </select>
          <select @change="onMonthYearChange" v-model="selectedYear" class="flex appearance-none w-16 h-8 pl-2 bg-white border border-solid rounded-sm border-grey-lightest text-sm text-grey-darkest focus:border-blue" >
            <option v-for="(year,index) in years" :key="index" v-bind:value="year">
              {{ year }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="flex px-10 mb-1 text-m font-semibold text-grey-darker tracking-wide" >DOCTOR'S ON SCHEDULE</div>
    <div class="flex flex-wrap bg-white px-8">
      <div @click='showAllDoctors()' class="text-grey text-center cursor-pointer text-sm flex-no-shrink flex-no-grow px-4 py-2 m-2 rounded-full "  v-bind:class="[autoSelectAllDoc ? 'bg-blue' : 'border border-solid border-grey-lightest']">
        <label class="text-xs cursor-pointer" for="Show All Doctor's" v-bind:class="[autoSelectAllDoc ? 'text-white' : 'text-black']">Show All Doctor's</label>
      </div>                                                                                                                         
      <div  @click='selectDoctors(i, doctor)' class="cursor-pointer text-red text-sm rounded-full flex-no-shrink flex-no-grow text-center bg-gray-400 px-4 py-2 m-2" v-for="(doctor,i) in doctors" :key="i" v-bind:class="[doctor.selected ? '' : 'border border-solid border-grey-lightest']" v-bind:style="[doctor.selected ? {'background': doctor.color} : {'background':'white'}]">
        <label class="text-xs cursor-pointer" v-bind:class="[doctor.selected ? 'text-white' : 'text-black']">{{doctor.name}}</label>    
      </div>
    </div>
    <!-- Table Starts Here-->
    <table class="mx-1 mt-2 w-full" style="overflow:scroll; height:calc(100vh - 12rem)" >
      <thead>
        <tr>
          <th class="h-full w-full sticky top-0 left-0 bg-white border-none p-0 m-0 shadow-none z-50" style="top:0; left:0"></th>
          <th  v-for="(time, i) in timeSlots" :key="i" class="z-40 flex flex-col w-full h-full sticky left-0 items-start p-0 bg-white cursor-default" style="left:0">
            <div class="flex font-semibold justify-end items-center w-full h-8 pr-4 mt-px bg-grey-lightest text-sm" style="box-shadow: 0px 0px 0px 1px #d7dbde; margin-left:1px">
              {{time}}
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(date, i) in dates" :key="i" >
          <td  class="flex sticky top-0 text-xs cursor-default p-1 font-semibold text-left justify-center items-center h-12 bg-grey-lightest z-40" style="box-shadow: inset 0px 0px 0px 1px #d7dbde; top:0">{{date | formatDateMonth}}</td>
          <td @click='openModal(showModal, slot, date)' v-for="(slot, index) in dateObject(date)" :key="index" class="flex flex-wrap p-2 bg-white hover:bg-blue-100 " v-bind:class="role === 'admin' ? 'cursor-pointer' : ''" > 
            <div v-for="(doc,i) in getDocsForASlot(slot, date)" :key="i" class="flex w-5 h-5 m-1 rounded-full text-white text-sm justify-center items-center leading-none flex-shrink-0" :title="doc.name" v-bind:style="{background:doc.color}">{{getDocInitials(doc.name)}}</div>
          </td>                   
        </tr>
      </tbody>
    </table>
    <div  v-if="showModal">
      <div  id="overlay"  @click='closeModal()' style="position: fixed; width: 100%; height: 100%; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.5); z-index: 100; cursor: pointer;"></div>
      <div  class="absolute flex flex-col bg-white shadow rounded-sm h-auto"  style="width: 550px; left: calc((100vw - 600px)/2); top:80px; height:auto; z-index: 110">
        <div class="w-full bg-grey flex flex-col px-5 py-4">
          <div class="text-lg" style="color: #207ae6">Manage Doctors</div>
          <div class="flex flex-row justify-between mt-2">
            <div class="text-sm">{{selectedDate}}</div>
            <div class="text-sm">{{selectedSlot}}</div>
          </div>
        </div>
        <!--Doctor list-->
        <div class="bg-white px-5 py-5">
          <div v-for="(doctor,i) in slotDoctors" :key="i" class="border border-solid border-gray-300 my-1 rounded-sm">
            <!-- border top has to be removed from 1st div-->  
            <div class="flex flex-row p-2 justify-between items-center border-solid border-gray-300">
              <div class="flex flex-row items-center m-1 mr-auto">
                <div class="rounded-full w-2 h-2 mr-2" v-bind:style="[{'background-color':doctor.color}]"></div>
                <div class="flex text-sm text-grey-darkest">{{doctor.name}}</div>
              </div>
              <!-- <div  > -->
              <div v-if="selectedDoctor.id === doctor.id && openReplaceDr" class="flex flex-col text-sm items-center ml-auto">
                <div @click='undoReplace(i)' class="flex text-grey-dark cursor-pointer ml-auto mb-1" style="">Undo</div>
                <div class='flex w-64'>
                  <select  class="flex cursor-pointer appearance-none w-auto h-8 bg-white border border-solid rounded-sm border-grey-lightest text-sm text-grey-darkest focus:border-blue" style="width: 400px;" @change="replaceHandler(i)">
                    <option class="" value="0">Select a doctor</option>
                    <option v-for="(doc,index) in dropdownDoctorList"  :key="index" v-bind:value="doc.id">
                      <div>{{ doc.name }}</div>
                    </option>
                  </select>
                </div>
              </div>
              <div v-else class="flex flex-row text-sm items-center">
                <div class="cursor-pointer"><img src="../../assets/replace.svg"></div>
                <div @click='replaceDoctor(i, doctor)' class="ml-2 text-grey cursor-pointer">Replace</div>
                <div  @click='deleteDoctor(i, doctor)' class="ml-2 cursor-pointer"><img src="../../assets/delete.svg"></div>
              </div>
            </div>
          </div>
        </div>
        <!--Add new doctor-->
        <div class="flex bg-white px-5" v-if="addDoctors">
          <select name="Replace doctor from selection" id="" class="flex appearance-none cursor-pointer w-full h-8 bg-white border border-solid rounded-sm border-grey-lightest text-sm text-grey-darkest focus:border-blue" @change="addHandler()">
            <option class="invisible" value="0">Add doctor from Selection</option>
            <option v-for="(doc,index) in dropdownDoctorList"  :key="index" v-bind:value="doc.id">
              <div>{{ doc.name }}</div>
            </option>
          </select>
        </div>
        <div @click='addDoctor()' class="bg-white px-5 py-4 flex flex-row justify-start items-center cursor-pointer">
          <div class="h-6 w-6 self-center"><img src="../../assets/plus.svg"></div>
          <div class="text-gray-600 text-sm ml-2 h-5">Add Doctor</div>
        </div>
        <!--Cancel and Save button-->
        <div class="bg-white flex flex-row justify-end px-5 py-4 mb-2">
          <div @click='closeModal()' class="border  ml-4 px-4 py-2 justify-center cursor-pointer rounded-sm  text-sm hover:shadow-md">Cancel</div>
          <div @click='updateChatSlot()' class="flex flex-col bg-blue ml-4 px-4 py-2 justify-center cursor-pointer rounded-sm text-white text-sm hover:shadow-md">Save Update</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import DocRosterAPI from './../../api/doctor_roster'
import moment from 'moment'
export default {
  data () {
    let today = moment(new Date())
    return {
      checkedMohanDr: false,
      checkedMaheshDr: false,
      checkedVarunDr: false,
      checkedArmanDr: false,
      showModal: false,
      openReplaceDr: false,
      selectedDoctor: {},
      isLoading: false,
      addDoctors: false,
      addSelectedDoctor: {},
      timeSlots: ['07:00-15:00', '15:00-23:00', '11:00-19:00'],
      doctors: [],
      years: [2022, 2023, 2024],
      months: [{text: 'January', value: '01'}, {text: 'Feburary', value: '02'}, {text: 'March', value: '03'}, {text: 'April', value: '04'}, {text: 'May', value: '05'}, {text: 'June', value: '06'},
      {text: 'July', value: '07'}, {text: 'August', value: '08'}, {text: 'September', value: '09'}, {text: 'October', value: 10}, {text: 'November', value: 11}, {text: 'December', value: 12}],
      selectedMonth: {value: today.format('MM'), text: today.format('MMMM')},
      selectedYear: today.format('YYYY'),
      response: [],
      slotDoctors: []
    }
  },
  mounted: function () {
    this.getDoctorsList()
    this.getDoctorChatSlots()
  },
  computed: {
    ...mapGetters({
      role: 'configuration/getRole'
    }),
    dates: function () {
      return Object.keys(this.response)
    },
    autoSelectAllDoc: function () {
      let noDocSelected = true
      this.doctors.map(function (doc) {
        if (doc.selected) {
          noDocSelected = false
        }
        return
      })
      return noDocSelected
    },
    dropdownDoctorList: function () {
      let doctorList = {}
      doctorList = this.doctors.filter(doctor => !this.slotDoctors.find(doc => doctor.id === doc.id))
      return doctorList
    }
  },
  methods: {
    getDocInitials: function (name) {
      name = name.toLocaleLowerCase()
      if (name.includes('dr.')) {
        let nameArr = name.split('dr.')
        return nameArr[1].trim().charAt(0).toUpperCase()
      } else if (name.includes('dr')) {
        let nameArr = name.split('dr')
        return nameArr[1].trim().charAt(0).toUpperCase()
      } else {
        return name.charAt(0).toUpperCase()
      }
    },
    onMonthYearChange: function () {
      this.getDoctorChatSlots()
    },
    getDoctorChatSlots: function () {
      let that = this
      DocRosterAPI.getDoctorChatSlots(this.selectedMonth.value, this.selectedYear)
      .then(response => {
        if (response.status === 200) {
          if (!response.body.slots) {
            this.$toast.open({
              message: 'Slots not available',
              type: 'warning',
              position: 'top',
              queue: false
            })
            let date = Object.keys(that.response)[0]
            if (date) {
              that.selectedMonth = {value: parseInt((moment(date, 'DD/MM/YYYY')).format('MM'))}
              that.selectedYear = parseInt((moment(date, 'DD/MM/YYYY')).format('YYYY'))
            }
            return
          }
          this.response = response.body.slots
        }
      }).catch((error) => {
        console.log('error is ', error)
      })
    },
    getDoctorsList: function () {
      let that = this
      DocRosterAPI.getDoctorsList()
      .then(response => {
        if (response.status === 200) {
          that.doctors = response.body.doctors.map(function (doc) {
            doc.selected = false
            return doc
          })
        }
      }).catch((error) => {
        console.log('error is ', error)
      })
    },
    openModal: function (showModal, slot, date) {
      if (this.role !== 'admin') {
        return
      }
      this.showModal = !this.showModal
      this.selectedSlot = slot
      this.selectedDate = date
      this.slotDoctors = this.getDocsForASlot(slot, date)
    },
    closeModal: function () {
      this.slotDoctors = []
      this.selectedDate = ''
      this.selectedSlot = ''
      this.selectedDoctor = {}
      this.showModal = false
      this.addDoctors = false
      this.openReplaceDr = false
      this.getDoctorChatSlots()
    },
    deleteDoctor: function (i) {
      this.slotDoctors.splice(i, 1)
    },
    replaceDoctor: function (i, doctor) {
      this.addDoctors = false
      this.openReplaceDr = !this.openReplaceDr
      this.selectedDoctor = doctor
    },
    replaceHandler: function (i) {
      let replaceDoctorId = parseInt(event.target.value)
      let dropdownSelectedDoctor = {}
      let removeDuplicateDoctor = {}
      dropdownSelectedDoctor = this.dropdownDoctorList.find(doctor => {
        if (replaceDoctorId === doctor.id) {
          return doctor
        }
      })
      removeDuplicateDoctor = this.slotDoctors.find(duplicateDoc => {
        if (replaceDoctorId === duplicateDoc.id) {
          return duplicateDoc
        }
      })
      if (dropdownSelectedDoctor === removeDuplicateDoctor) {
        this.$toast.open({
          message: 'Doctor is already present in the slot',
          type: 'warning',
          position: 'top',
          queue: false
        })
      } else {
        this.slotDoctors.splice(i, 1, dropdownSelectedDoctor)
      }
    },
    undoReplace: function (i) {
      this.openReplaceDr = false
    },
    addDoctor: function (addDoctors) {
      this.openReplaceDr = false
      this.addDoctors = !this.addDoctors
    },
    addHandler: function () {
      let addDoctorId = parseInt(event.target.value)
      let addSelectedDoctor = this.dropdownDoctorList.find(doctor => {
        if (addDoctorId === doctor.id) {
          return doctor
        }
      })
      let removeDuplicateSelectedDoc = this.slotDoctors.find(duplicateSelectDoc => {
        if (addDoctorId === duplicateSelectDoc.id) {
          return duplicateSelectDoc
        }
      })
      if (addSelectedDoctor === removeDuplicateSelectedDoc) {
        this.$toast.open({
          message: 'Doctor is already present in the slot',
          type: 'warning',
          position: 'top',
          queue: false
        })
      } else {
        this.slotDoctors.push(addSelectedDoctor)
      }
      this.addDoctors = false
    },
    dateObject: function (date) {
      if (Object.keys(this.response[date]).length > 0) {
        return Object.keys(this.response[date])
      }
      return []
    },
    getDocsForASlot (slot, date) {
      if (this.response[date][slot].length > 0) {
        if (this.autoSelectAllDoc) {
          return this.response[date][slot]
        } else {
          let resp = []
          let that = this
          this.response[date][slot].map(function (doc) {
            that.doctors.filter(doc => { return doc.selected }).map(function (selectedDoc) {
              if (doc.id === selectedDoc.id) {
                resp.push(doc)
              }
            })
          })
          return resp
        }
      }
      return []
    },
    selectDoctors: function (i, doc) {
      this.doctors[i].selected = !this.doctors[i].selected
    },
    showAllDoctors: function () {
      this.doctors.map(doctor => { doctor.selected = false })
    },
    updateChatSlot: function () {
      if (this.role !== 'admin') {
        this.$toast.open({
          message: 'Not Authorised',
          type: 'warning',
          position: 'top',
          queue: false
        })
        return
      }
      let doctorIds = this.slotDoctors.map(a => a.id)
      var res = this.selectedSlot.split('-')
      let that = this
      DocRosterAPI.updateChatSlot({
        doctor_ids: doctorIds,
        date: this.selectedDate,
        start_time: res[0],
        end_time: res[1]
      })
      .then(response => {
        if (response.status === 200) {
          this.showModal = false
          this.$toast.open({
            message: 'Chat Availability updated successfully',
            type: 'success',
            position: 'top',
            queue: false
          })
          that.getDoctorChatSlots()
        }
      }).catch((error) => {
        console.log('error is ', error)
        this.$toast.open({
          message: 'Chat Availability updated failed',
          type: 'error',
          position: 'top',
          queue: false
        })
      })
    }
  }
}
</script>

<style scoped>
  table{
      display: grid;
      grid-template-columns: 148px repeat(31, 72px);
      grid-template-rows: 48px repeat(3,72px);
      grid-auto-flow: column;
  }
  thead,tbody,tr {
      display: contents;
  }
  /* CSS + selector is used to apply box-shadow to all the TD that are placed immediately after TD */
  td + td  {
      box-shadow: inset 0px 0px 0px 0.5px #d7dbde;
  }
  th {
    font-weight: normal
  }
  /* Circlur dot for each doctor*/
  .doc-circle{
      width: 20px;
      height: 20px;
      border-radius: 50%;
      color: white;
      /* font-size: 12px; */
      background-color: darkgrey; /* default circular background base color */
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      margin: 4px;
      flex-shrink: 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/Admin/DoctorChatAvailability.vue